// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useRef, useState } from 'react';
import { SupportMessageType } from '../../../../types/Model';
import S from './styles';

export interface PopupPreviewProps {
  time: string;
  message: string;
  username: string;
  imagesUrls: string[];
  currentPhotoId: number;
  setShowPreview: React.Dispatch<React.SetStateAction<{
    time: string;
    message: string;
    username: string;
    imagesUrls: string[];
    currentPhotoId: number;
  } | undefined>>
}

const Popup = (props: PopupPreviewProps): JSX.Element => {
  const {
    time,
    message,
    username,
    imagesUrls,
    currentPhotoId,
    setShowPreview
  } = props
  const popupContainerRef = useRef<HTMLDivElement>(null);
  const [currentPreview, setCurrentPreview] = useState(currentPhotoId);

  useEffect(() => {
    setCurrentPreview(currentPhotoId)
  }, [])
  useEffect(() => {
    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const close = () => {
    setShowPreview(undefined)
  }
  const handleClickOutside = (e: MouseEvent) => {
    const ref = popupContainerRef.current;
    if (ref) {
      const target = e.target;
      if (target instanceof Node)
        if (ref.contains(target)) {
          // inside click
          return;
        }
    }
    // outside click
    close()
  };

  const moveLeft = () => {
    const newCurrentPreview = currentPreview === 0 ? imagesUrls.length - 1 : currentPreview - 1
    setCurrentPreview(newCurrentPreview)
  }

  const moveRight = () => {
    const newCurrentPreview = currentPreview === imagesUrls.length - 1 ? 0 : currentPreview + 1
    setCurrentPreview(newCurrentPreview)
  }
  return (
    <S.Container>
      <S.PopupBox ref={popupContainerRef} >
        <S.CloseButton onClick={close} />
        <S.BodyWrapper>
          <S.LeftSideWrapper>
            <S.Username>
              {username}
            </S.Username>
            <S.Time>
              {time}
            </S.Time>
            <S.Message>
              {message}
            </S.Message>
          </S.LeftSideWrapper>
          <S.RightSideWrapper>
            <S.ArrowLeft onClick={moveLeft} />
            <S.ImageWrapper >
              <S.ImagePreview src={imagesUrls[currentPreview]} />
              <S.ImageListWrapper >
                {imagesUrls.map((data, index) => {
                  return (
                    <S.ImageListItem key={index} src={data} onClick={() => setCurrentPreview(index)} />
                  )
                })}
              </S.ImageListWrapper>
            </S.ImageWrapper >
            <S.ArrowRight onClick={moveRight} />
          </S.RightSideWrapper>
        </S.BodyWrapper>
      </S.PopupBox>
    </S.Container>
  )
}

export { Popup as default };
